import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

import { PeopleCardService } from '../../services/people-card.service';

@Directive({
    selector: '[ohpPeopleCard]'
})
export class PeopleCardDirective implements OnInit, OnDestroy {
    @Input('ohpPeopleCard') public upn: string;

    private renderPromise: Promise<void>;

    constructor(
        private readonly elementRef: ElementRef,
        private readonly peopleCardService: PeopleCardService
    ) {
    }

    public ngOnInit() {
        if (this.upn) {
            this.renderPromise = this.peopleCardService.addPersonaCard(this.elementRef.nativeElement, this.upn);
        }
    }

    public ngOnDestroy() {
        if (this.renderPromise) {
            this.renderPromise.then(() => {
                this.peopleCardService.removePersonaCard(this.elementRef.nativeElement, this.upn);
            });
        }
    }
}
